export default {"src":"/_next/static/media/note-blue.39fe2c8d.svg","height":8,"width":44,"blurWidth":0,"blurHeight":0};